import _pick from 'lodash/pick';

import { UPDATE_CHECKLIST, UPDATE_CHECKLIST_ITEM } from 'constants/actions';
import * as checklist from 'constants/checklist';
import * as userStatus from 'constants/userStatus';

import { SLACK } from '../../../shared/constants/oAuthKeys';
import { hasSlackAppScopes } from '../../../shared/utilities/slack';

const DEFAULT_CHECKLIST_STATE = {
  [checklist.CUSTOMIZE_VIDEO_NAME]: false,
  [checklist.COMPLETE_ONBOARDING]: false,
  [checklist.CUSTOMIZE_VIDEO_NAME]: false,
  [checklist.FILLED_ACCOUNT_SETTINGS]: false,
  [checklist.FIRST_CAM_RECORDING]: false,
  [checklist.FIRST_VIDEO_RECORDING]: false,
  [checklist.FIRST_VIDEO_UPLOAD]: false,
  [checklist.FOLLOWED_US_ON_TWITTER]: false,
  [checklist.LIKED_US_ON_FACEBOOK]: false,
  [checklist.SHARED_FIRST_VIDEO_ON_FACEBOOK]: false,
  [checklist.TWEETED_FIRST_VIDEO]: false,
  [checklist.FIRST_VIDEO_VIEWED]: false,
  [checklist.EMAIL_VERIFIED_FRONTEND_ONLY]: false,
  [checklist.HAS_VIEWED_VIDEOS]: false,
  [checklist.HAS_VIEWED_SCREENSHOTS]: false,
  [checklist.HAS_REACHED_RECORDING_LIMIT]: false,
  [checklist.CREATE_ACCOUNT]: true,
  [checklist.DOWNLOAD_RECORDER]: false,
  [checklist.SHARE_VIDEO]: false,
  [checklist.ADD_TEAMMATE]: false,
  getStartedChecklistBannerExpanded: false,
};

const checklistReducer = (state = DEFAULT_CHECKLIST_STATE, action) => {
  let currentUserStatus;
  let currentUserSlack;

  if (action.user != null) {
    currentUserStatus = action.user.status;
    currentUserSlack = action.user.oauth && action.user.oauth[SLACK];
  }

  switch (action.type) {
    case UPDATE_CHECKLIST_ITEM:
      return Object.assign({}, state, {
        [action.payload.item]: action.payload.value,
      });
    case UPDATE_CHECKLIST:
      return Object.assign(
        {},
        state,
        _pick(action.user.checklist, checklist.ALL),
        {
          [checklist.EMAIL_VERIFIED_FRONTEND_ONLY]:
            currentUserStatus != null &&
            currentUserStatus === userStatus.VERIFIED,
          [checklist.SLACK_APP_ADDED_FRONTENT_ONLY]:
            currentUserSlack && hasSlackAppScopes(currentUserSlack.scopes),
        }
      );
    default:
      return state;
  }
};

export default checklistReducer;
